(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/behaviors/lotto-rule-change-info.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/behaviors/lotto-rule-change-info.js');

'use strict';

svs.lotto.components.play.behaviors.lottoRuleChangeInfo = Marionette.Behavior.extend({
  ui: {
    showFullscreenInfo: '#show-fullscreen-info'
  },
  events: {
    'click @ui.showFullscreenInfo': 'onShowFullscreenInfoClick'
  },
  modelEvents: {
    'change:drawCount': 'onUpdateShowInfo',
    'change:selectedDays': 'onUpdateShowInfo'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent
  }],
  onInitialize() {
    this.isInfoVisible = false;
    this.firstPlayableDraw = svs.numbergames.draws.drawsApi.firstPlayableDraw(this.view.model.get('productId'));
    const {
      productId: product,
      drawNumber
    } = this.firstPlayableDraw[svs.numbergames.game.draw.upcomingDrawProduct];
    this.isNewRules = svs.numbergames.rules.utils.lotto.isNewRules({
      product,
      drawNumber
    });
    this.handleNavigationChange = this.handleNavigationChange.bind(this);
    window.addEventListener('popstate', this.handleNavigationChange);
  },
  onRender() {
    this.onUpdateShowInfo(false);
  },
  showInfo() {
    let shouldScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (this.isInfoVisible) return;
    this.isInfoVisible = true;
    const isNewRules = this.isNewRules;
    this.view.showChildView(this.options.ruleChangeInfoRegionSelector, {
      template() {
        return svs.lotto.components.play.templates.lotto_rule_change_info({
          isNewRules
        });
      }
    });
    requestAnimationFrame(() => {
      const container = document.querySelector('.lotto-rule-change-info-container');
      const content = document.querySelector('.js-lotto-rule-change-info');
      gsap.set(container, {
        height: 0,
        overflow: 'hidden'
      });
      gsap.set(content, {
        opacity: 0,
        y: -100
      });
      const animateIn = () => {
        gsap.to(container, {
          height: 'auto',
          duration: 0.4
        });
        gsap.to(content, {
          y: 0,
          duration: 0.4,
          opacity: 1,
          ease: 'power2.out'
        });
      };
      if (shouldScroll) {
        const rect = content.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const isOutOfViewport = rect.bottom > viewportHeight - rect.height;
        if (isOutOfViewport) {
          const targetScrollY = window.scrollY + rect.bottom + rect.height - window.innerHeight + 50;
          window.scrollTo({
            top: targetScrollY,
            behavior: 'smooth'
          });
          setTimeout(animateIn, 300);
          return;
        }
      }
      animateIn();
    });
  },
  hideInfo() {
    if (!this.isInfoVisible) return;
    const container = document.querySelector('.lotto-rule-change-info-container');
    this.isInfoVisible = false;
    gsap.to(container, {
      height: 0,
      duration: 0.3,
      onComplete: () => {
        var _this$view$getRegion, _this$view$getRegion$;
        this.removeFullscreen();
        (_this$view$getRegion = this.view.getRegion(this.options.ruleChangeInfoRegionSelector)) === null || _this$view$getRegion === void 0 || (_this$view$getRegion = _this$view$getRegion.currentView) === null || _this$view$getRegion === void 0 || (_this$view$getRegion$ = _this$view$getRegion.destroy) === null || _this$view$getRegion$ === void 0 || _this$view$getRegion$.call(_this$view$getRegion);
      }
    });
  },
  handleNavigationChange() {
    if (history.state && history.state.fullscreen) {
      this.showFullscreen();
    } else {
      this.removeFullscreen();
      history.replaceState({}, '', window.location.pathname);
    }
  },
  fullscreenClosingAction() {
    const closeCarousel = event => {
      event.preventDefault();
      event.stopPropagation();
      this.removeFullscreen();
      history.replaceState({}, '', window.location.pathname);
    };
    const carouselItems = document.querySelectorAll('.ui-carousel-item');
    const lastAdInCarousel = carouselItems[carouselItems.length - 1];
    if (lastAdInCarousel) {
      const closeButtonArea = lastAdInCarousel.querySelector('.ui-carousel-actions');
      if (closeButtonArea) {
        closeButtonArea.addEventListener('click', closeCarousel);
        this._closeButtonArea = closeButtonArea;
        this._closeCarouselHandler = closeCarousel;
      }
    }
  },
  showFullscreen() {
    const container = document.getElementById('lotto-fullscreen-container');
    if (container) {
      document.body.style.overflow = 'hidden';
      ReactDOM.render(React.createElement(svs.components.onboarding.widgetAreaFullscreen.WidgetAreaFullscreen, {
        onCloseFullscreen: () => {
          history.replaceState({}, '', window.location.pathname);
          this.handleNavigationChange();
        },
        widgetAreaName: 'lottoFullscreenWidgetArea',
        branding: 'lotto'
      }), container);
    }
    setTimeout(() => {
      this.fullscreenClosingAction();
    }, 500);
  },
  onUpdateShowInfo() {
    var _this$firstPlayableDr;
    let shouldScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let productItsId;
    if (this.view.model.get('selectedDays').length === 1) {
      productItsId = this.view.model.get('selectedDays')[0];
    } else {
      productItsId = svs.numbergames.game.draw.upcomingDrawProduct;
    }
    const draw = (_this$firstPlayableDr = this.firstPlayableDraw[productItsId]) !== null && _this$firstPlayableDr !== void 0 ? _this$firstPlayableDr : {};
    const isShowRuleChangeInfo = svs.numbergames.rules.utils.lotto.showRuleChangeInfo({
      product: productItsId,
      firstDraw: draw.drawNumber,
      lastDraw: draw.drawNumber + parseInt(this.view.model.get('drawCount'), 10) - 1
    });
    const shouldShow = isShowRuleChangeInfo || this.view.model.get('isSubscription') && svs.core.detect.feature('ft-lotto-rule-change');
    if (shouldShow && !this.isInfoVisible) {
      this.showInfo(shouldScroll);
    } else if (!shouldShow && this.isInfoVisible) {
      this.hideInfo();
    }
  },
  onShowFullscreenInfoClick() {
    if (!history.state || !history.state.fullscreen) {
      history.pushState({
        fullscreen: true
      }, '', '');
    }
    this.showFullscreen();
  },
  removeFullscreen() {
    const container = document.getElementById('lotto-fullscreen-container');
    if (container) {
      document.body.style.overflow = 'visible';
      ReactDOM.unmountComponentAtNode(container);
      container.innerHTML = '';
    }
    if (this._closeButtonArea && this._closeCarouselHandler) {
      this._closeButtonArea.removeEventListener('click', this._closeCarouselHandler);
      this._closeButtonArea = null;
      this._closeCarouselHandler = null;
    }
  }
});

 })(window);